'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveAddressDetails = saveAddressDetails;
exports.saveEmail = saveEmail;
exports.saveCPFNumber = saveCPFNumber;
exports.toggleUseShipping = toggleUseShipping;
exports.enablePostcodeLookup = enablePostcodeLookup;
exports.disablePostcodeLookup = disablePostcodeLookup;
var SAVE_ADDRESS_DETAILS_IN_FORM = exports.SAVE_ADDRESS_DETAILS_IN_FORM = 'SAVE_ADDRESS_DETAILS_IN_FORM';
var ENABLE_POSTCODE_LOOKUP = exports.ENABLE_POSTCODE_LOOKUP = 'ENABLE_POSTCODE_LOOKUP';
var DISABLE_POSTCODE_LOOKUP = exports.DISABLE_POSTCODE_LOOKUP = 'DISABLE_POSTCODE_LOOKUP';
var SAVE_EMAIL_IN_ADDRESS_DETAILS_FORM = exports.SAVE_EMAIL_IN_ADDRESS_DETAILS_FORM = 'SAVE_EMAIL_IN_ADDRESS_DETAILS_FORM';
var SAVE_CPF_NUMBER_IN_ADDRESS_DETAILS_FORM = exports.SAVE_CPF_NUMBER_IN_ADDRESS_DETAILS_FORM = 'SAVE_CPF_NUMBER_IN_ADDRESS_DETAILS_FORM';
var TOGGLE_USE_SHIPPING = exports.TOGGLE_USE_SHIPPING = 'TOGGLE_USE_SHIPPING';

function saveAddressDetails(prefix, fieldName, value) {
  return { type: SAVE_ADDRESS_DETAILS_IN_FORM, prefix: prefix, fieldName: fieldName, value: value };
}

function saveEmail(value) {
  return { type: SAVE_EMAIL_IN_ADDRESS_DETAILS_FORM, value: value };
}

function saveCPFNumber(value) {
  return { type: SAVE_CPF_NUMBER_IN_ADDRESS_DETAILS_FORM, value: value };
}

function toggleUseShipping() {
  return { type: TOGGLE_USE_SHIPPING };
}

function enablePostcodeLookup(prefix) {
  return { type: ENABLE_POSTCODE_LOOKUP, prefix: prefix };
}

function disablePostcodeLookup(prefix) {
  return { type: DISABLE_POSTCODE_LOOKUP, prefix: prefix };
}


//////////////////
// WEBPACK FOOTER
// ./shared/actions/addressForm.js
// module id = 355
// module chunks = 0